<formio-loader></formio-loader>
<div *ngIf="!viewOnly" class="tree-header">
    <button (click)="createDialog(true, customOptions)" *ngIf="name" class="btn btn-primary btn-md">
    {{ "forms.common.Add" | translate }}
    {{ "forms.common." + name | translate }}
  </button>

    <button (click)="removeBulk()" *ngIf="checklistSelection.hasValue()" class="delete-selection" color="primary" mat-button>
    <mat-icon class="action delete">delete</mat-icon>
    {{ "forms.common.Delete Selected Items" | translate }}
  </button>
</div>

<mat-tree *ngIf="dir" [dataSource]="treeSource" [trackBy]="trackBy" [treeControl]="treeControl" [dir]="dir"
[class.mt-3]="!viewOnly"
>
    <mat-tree-node *matTreeNodeDef="let node" class="leave" matTreeNodeToggle>
        <li class="mat-tree-node" renderDebug>
            <div class="center-content">
                <button disabled mat-icon-button></button>
                <!-- <mat-checkbox (change)="todoLeafItemSelectionToggle(node)" *ngIf="!viewOnly" [checked]="checklistSelection.isSelected(node)">
                </mat-checkbox> -->
                <span [innerHTML]="node.name | safeHtml"></span>
                <span *ngIf="viewOnly" [innerHTML]="node.name | safeHtml"></span>
            </div>

            <div class="actions">
                <span *ngIf="!viewOnly">
          <ng-container *ngFor="let btn of node.actions">
            <mat-icon
              fontSet="material-icons-outlined"
              (click)="createNode(node, btn.bindWith)"
              *ngIf="btn.name == 'action'"
              [matTooltipPosition]="'above'"
              [matTooltip]="
                ('forms.common.Add' | translate) +
                ' ' +
                ('forms.common.' + btn.bindWith | translate)
              "
              class="action add"
              >add
            </mat-icon>
          </ng-container>
        </span>
                <mat-icon fontSet="material-icons-outlined" (click)="viewDialog(node)" class="action view">visibility</mat-icon>
                <mat-icon fontSet="material-icons-outlined" (click)="editDialog(node)" *ngIf="!viewOnly && hasAction(node, 'edit')" class="action edit">
                    edit
                </mat-icon>
                <mat-icon fontSet="material-icons-outlined" (click)="removeNode(node)" *ngIf="!viewOnly && hasAction(node, 'delete')" class="action delete">delete
                </mat-icon>
            </div>
        </li>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <li class="mat-tree-node" renderDebug>
            <div class="center-content mat-tree-node">
                <button [attr.aria-label]="'Toggle ' + node.name" mat-icon-button matTreeNodeToggle>
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
          </mat-icon>
        </button>
                <!-- <mat-checkbox (change)="todoItemSelectionToggle(node)" *ngIf="!viewOnly" [checked]="checklistSelection.isSelected(node)" [indeterminate]="descendantsPartiallySelected(node)">
                </mat-checkbox> -->
                <span [innerHTML]="node.name | safeHtml"></span>
                <span *ngIf="viewOnly" [innerHTML]="node.name | safeHtml"></span>
            </div>
            <div class="actions">
                <span *ngIf="!viewOnly">
          <ng-container *ngFor="let btn of node.actions">
            <mat-icon
              (click)="createNode(node, btn.bindWith)"
              *ngIf="btn.name == 'action'"
              [matTooltipPosition]="'above'"
              [matTooltip]="
                ('forms.common.Add' | translate) +
                ' ' +
                ('forms.common.' + btn.bindWith | translate)
              "
              class="action add"
              fontSet="material-icons-outlined"
              >add
            </mat-icon>
          </ng-container>
        </span>

                <mat-icon (click)="viewDialog(node)" class="action view" fontSet="material-icons-outlined">visibility</mat-icon>
                <mat-icon fontSet="material-icons-outlined" (click)="editDialog(node)" *ngIf="!viewOnly && hasAction(node, 'edit')" class="action edit">
                    edit
                </mat-icon>
                <mat-icon fontSet="material-icons-outlined" (click)="removeNode(node)" *ngIf="!viewOnly && hasAction(node, 'delete')" class="action delete">delete
                </mat-icon>
            </div>
        </li>
        <ul [class.children-invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
        </ul>
    </mat-nested-tree-node>
</mat-tree>